module.exports = __webpack_public_path__ + "static/img/commitment-5_light.39858635.png";